// @flow

import React, { type ComponentType } from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getColors } from '../../../../../../store/configuration/actives';
import {
  getActiveColorId,
  getActiveColor,
  selectColor,
} from '../../../../../../store/configuration';
import type { PackageColor } from '../../../../../../types/pdb';

type DispatchProps = {|
  setColor: Function,
|};

type OwnProps = {|
  pdbId: ?string, // eslint-disable-line react/no-unused-prop-types
  excludeColorIds?: ?Array<number>,
  variant?: string, // eslint-disable-line react/no-unused-prop-types
  blocksPerRow?: number, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  colors: Array<PackageColor>,
  activeColorId: ?number,
  activeColor: ?PackageColor,
|};

type Props = {|
  ...DispatchProps,
  ...StateProps,
  ...OwnProps,
|};

const withPdbColors = (WrappedComponent: ComponentType<*>) => {
  const PdbColors = ({
    setColor, colors, activeColor, activeColorId, excludeColorIds,
  }: Props) => {
    let filteredColors = colors;
    if (excludeColorIds) {
      filteredColors = colors.filter(color => !excludeColorIds.includes(color.id));
    }
    return (
      <WrappedComponent
        setColor={setColor}
        colors={filteredColors}
        activeColor={activeColor}
        activeColorId={activeColorId}
      />
    );
  };

  PdbColors.defaultProps = {
    excludeColorIds: null,
    variant: '',
    blocksPerRow: 1,
  };

  const mapStateToProps = (state, { pdbId }: OwnProps): StateProps => ({
    colors: getColors(state, pdbId),
    activeColor: getActiveColor(state, pdbId),
    activeColorId: getActiveColorId(state, pdbId),
  });

  const mapDispatchToProps = (dispatch: Dispatch<any>, { pdbId }: OwnProps): DispatchProps => ({
    setColor: (id: number) => dispatch(selectColor(id, pdbId)),
  });

  return connect<any, OwnProps, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  )(PdbColors);
};

export default withPdbColors;
